import { useContext, useEffect, useState } from "react";
import { ReportService } from "../../../../services/report";
import { Box, Grid, FormControl, Autocomplete, TextField, Button, Typography } from "@mui/material";
import { AppLayout } from "../../../../layouts/app";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"; import { Link } from "react-router-dom";
import { BreadcrumbContext } from "../../../../contexts/breadcrumb";
import { TrackersService } from "../../../../services/trackers";
import {
    DataGrid, ptBR,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
    GridToolbarExport,
} from "@mui/x-data-grid";
import moment from "moment-timezone";
import { NotificationManager } from "react-notifications";

export const MessageRS232 = () => {
    const date = new Date();
    const reportService = new ReportService();
    const trackersService = new TrackersService();
    const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
    const [trackers, setTrackers] = useState([]);
    const [trackerSelected, setTrackerSelected] = useState("");
    const [initialDate, setInitialDate] = useState(
        new Date(date.getFullYear(), date.getMonth(), 1).toISOString()
    );
    const [finalDate, setFinalDate] = useState(new Date(Date.now()));
    const [loadingData, setLoadingData] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        const breadcrumbsState = [
            <Link key="1" to="/">
                Home
            </Link>,
            <Typography key="2" color="text.primary">
                Mensagem  UEX
            </Typography>,
        ];

        getTrackers();
        setBreadcrumbs(breadcrumbsState);
    }, []);

    const getTrackers = () => {
        trackersService
            .getTrackers()
            .then((res) => {
                let opt = [];
                res.data.map((value) => {
                    opt.push({ label: value.deviceId.toString() })
                });
                setTrackers(opt);

            })
            .catch((err) => {
            });
    };

    const handleChangeInitialDate = (date) => {
        setInitialDate(date);

    };

    const handleChangeFinalDate = (date) => {
        setFinalDate(date)
    }

    const handleReportsGenerate = () => {
        const startDate = moment(initialDate).format("DD/MM/YYYY, HH:mm:ss");
        const endDate = moment(finalDate).format("DD/MM/YYYY, HH:mm:ss");
        setLoadingData(true);
        var result = calculateDifferenceInDays(finalDate, initialDate);
        if (result <= 10) {
            reportService.getDocumentsRs232Info(trackerSelected, startDate, endDate).then((response) => {
                if (response.status === 204) {
                    setData([]);
                    NotificationManager.warning(
                        "Sem dados para gerar relatório com os filtros selecionados.", "", 3000
                    );
                } else {
                    let data = [];
                    response.data.map((element, index) => {
                        data.push({
                            "index": index,
                            "backupVoltate": element.backupVoltate,
                            "cell": element.cell,
                            "checkSum": element.checkSum,
                            "course": element.course,
                            "createdAt": element.createdAt,
                            "createdBy": element.createdBy,
                            "date": element.date,
                            "dateTimeGPS": element.dateTimeGPS,
                            "deviceId": element.deviceId,
                            "didReg": element.didReg,
                            "dist": element.dist,
                            "driverHourMeter": element.driverHourMeter,
                            "driverId": element.driverId,
                            "fix": element.fix,
                            "id": element.id,
                            "ioStatus": element.ioStatus,
                            "latitude": element.latitude,
                            "len": element.len,
                            "longitude": element.longitude,
                            "messageType": element.messageType,
                            "model": element.model,
                            "numberOfSatt": element.numberOfSatt,
                            "oStatus": element.oStatus,
                            "powerVoltage": element.powerVoltage,
                            "reportHeader": element.reportHeader,
                            "rs232Data": element.rs232Data,
                            "speed": element.speed,
                            "swVersion": element.swVersion,
                            "time": element.time,
                            "updatedAt": element.updatedAt,
                            "updatedBy": element.updatedBy,
                        });
                    })

                    setData(data);
                }
                setLoadingData(false);
            }).catch((error) => {
                console.error(error);
                setLoadingData(false);
                setData([]);
            })
        } else {
            NotificationManager.warning("Período maior que dez dias.", "", 3000);
            setLoadingData(false);
        }

    }

    const calculateDifferenceInDays = (date1, date2) => {
        const oneDay = 24 * 60 * 60 * 1000;
        const diffInMilliseconds = Math.abs(date1 - date2);
        return Math.round(diffInMilliseconds / oneDay);
    };

    const columns = [
        {
            field: "createdAt",
            headerAlign: "center",
            align: "center",
            headerClassName: "super-app-theme--header",
            headerName: "Data Criação",
            minWidth: 200,
            flex: 1,
            renderCell: ({ row }) => row.createdAt
        },
        {
            field: "createdBy",
            headerAlign: "center",
            align: "center",
            headerClassName: "super-app-theme--header",
            headerName: "Criado por",
            minWidth: 110,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.createdBy
        },
        {
            field: "reportHeader",
            headerAlign: "center",
            align: "center",
            headerClassName: "super-app-theme--header",
            headerName: "Cabeçalho",
            minWidth: 100,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.reportHeader

        },
        {
            field: "deviceId",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
            headerName: "ID Rastreador",
            minWidth: 175,
            flex: 1,
            sortable: false,
            align: "center",
            renderCell: ({ row }) => row.deviceId
        },
        {
            field: "model",
            headerAlign: "center",
            align: "center",
            headerClassName: "super-app-theme--header",
            headerName: "Modelo",
            minWidth: 75,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.model
        },
        {
            field: "swVersion",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Versão SW",
            minWidth: 100,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.swVersion,
        },
        {
            field: "date",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Data GPS",
            minWidth: 90,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.date,
        },
        {
            field: "time",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Tempo GPS",
            minWidth: 110,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.time,
        },
        {
            field: "cell",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Cell",
            minWidth: 75,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.cell
        },
        {
            field: "latitude",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Latitude",
            minWidth: 75,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.latitude
        },
        {
            field: "longitude",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Longitude",
            minWidth: 100,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.longitude,
        },
        {
            field: "speed",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Velocidade",
            minWidth: 100,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.speed,
        },
        {
            field: "course",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Course",
            minWidth: 100,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.course,
        },
        {
            field: "numberOfSatt",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Nº Satélite",
            minWidth: 105,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.numberOfSatt,
        },
        {
            field: "fix",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Fix",
            minWidth: 105,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.fix,
        },
        {
            field: "dist",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Dist",
            minWidth: 105,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.dist,
        },
        {
            field: "powerVoltage",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Tensão Bateria",
            minWidth: 120,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.powerVoltage,
        },
        {
            field: "ioStatus",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "IOStatus",
            minWidth: 105,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.ioStatus,
        },

        {
            field: "oStatus",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "OStatus",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.oStatus,
        },
        {
            field: "len",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Len",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.len,
        },
        {
            field: "rs232Data",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "RS232",
            minWidth: 1150,
            flex: 0,
            sortable: false,
            renderCell: ({ row }) => row.rs232Data,
        },
        {
            field: "checkSum",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "CheckSum",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.checkSum,
        },
        {
            field: "driverHourMeter",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "DriverHourMeter",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.driverHourMeter,
        },
        {
            field: "backupVoltate",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Bateria Backup",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.backupVoltate,
        },
        {
            field: "messageType",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "Tipo da Mensagem",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.messageType,
        },
        {
            field: "driverId",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "ID Motorista",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.driverId,
        },
        {
            field: "didReg",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            align: "center",
            headerName: "DidReg",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: ({ row }) => row.didReg,
        },
    ]

    const configBox = {
        height: "65vh",
        width: "100%",
        "& .dataGrid-true": {
            bgcolor: "#eeeeee",
        },
        "& .dataGrid-false": {
            bgcolor: "#ffffff",
        },
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton
                    title="Exibir Colunas"
                    sx={{ color: "#414141" }}
                    size="5px"
                />
                <GridToolbarFilterButton
                    componentsProps={{ button: { variant: "outlined" } }}
                    title="Selecionar Filtros"
                    sx={{ color: "#414141" }}
                    size="5px"
                />
                <GridToolbarDensitySelector
                    title="Espessura das linhas"
                    sx={{ color: "#414141" }}
                    size="5px"
                />
                <GridToolbarExport sx={{ color: "#414141" }} size="5px" csvOptions={{
                    delimiter: ';',
                    utf8WithBom: true,
                }} />
            </GridToolbarContainer>
        );
    }

    return (
        <AppLayout>
            <Box
                component="form"
                noValidate
            >
                <Grid container display={'flex'} flexWrap={'nowrap'} justifyContent={'space-between'} alignItems={'center'}>
                    <Grid item xs={3}>
                        <FormControl>
                            <Autocomplete
                                disablePortal
                                options={trackers}
                                onChange={(e, newValue) =>
                                    setTrackerSelected(newValue.label)
                                }
                                sx={{ width: 260, padding: "10px" }}
                                size="small"
                                renderInput={(params) => (
                                    <TextField {...params} label="ID Rastreador" />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} >
                        <FormControl style={{ display: 'flex', flexDirection: 'row' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    label="Data de Início"
                                    onChange={(e) => handleChangeInitialDate(e.$d)}
                                    value={initialDate}
                                    size="small"
                                    inputFormat="DD/MM/YYYY HH:mm:ss"
                                    renderInput={(params) => (
                                        <TextField
                                            sx={{ width: 260, padding: "10px" }}
                                            size="small"
                                            {...params}
                                        />
                                    )}
                                    minDate={
                                        new Date(date.getFullYear(), date.getMonth() - 3, 1)
                                    }
                                />
                            </LocalizationProvider>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    label="Data de Término"
                                    onChange={(e) => handleChangeFinalDate(e.$d)}
                                    value={finalDate}
                                    size="small"
                                    inputFormat="DD/MM/YYYY HH:mm:ss"
                                    renderInput={(params) => (
                                        <TextField
                                            sx={{ width: 260, padding: "10px" }}
                                            size="small"
                                            {...params}
                                        />
                                    )}
                                    minDate={
                                        new Date(date.getFullYear(), date.getMonth() - 3, 1)
                                    }
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>
                    <Grid item xs={2}>
                        <FormControl style={{ float: "right" }}>
                            <Button
                                size={'medium'}
                                disabled={trackerSelected === "" ? true : false}
                                style={{ background: "#008000", color: "white", boxShadow: "1px 1px 5px 1px rgba(165, 165, 165, 0.82)" }}
                                onClick={handleReportsGenerate}
                            >
                                Gerar Relatório
                            </Button>
                        </FormControl>
                    </Grid>
                </Grid>

            </Box>

            <Box sx={configBox}>
                <DataGrid
                    loading={loadingData}
                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    rows={data}
                    columns={columns}
                    disableColumnMenu
                    rowsPerPageOptions={[5, 10, 20, 50, 70, 100]}
                    experimentalFeatures={{ newEditingApi: true }}
                    rowHeight={50}
                    density={'compact'}
                    getRowClassName={(params) => {
                        return params.row.index % 2 === 0 ? "highlight" : "white";
                    }}
                    sx={{
                        ".highlight": {
                            bgcolor: "rgba(166,166,166,0.5)",
                            "&:hover": {
                                bgcolor: "darkgrey",
                            },
                        },
                    }}
                />
            </Box>
        </AppLayout>
    );
}